<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Invoice, ServicesOnInvoices } from '../../../modules/posApi/invoices/invoice'
    import LoadSpinner from '../../_common/load-spinner.svelte'

    interface ServiceRow {
        name: string
        value: number
        sales: number
    }

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let grid: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: Invoice[] = await window.api.pos.invoices.getAll({ from, to, service: true })
        let items: ServicesOnInvoices[] = data.flatMap((invoice) => invoice.services || [])
        items = await window.api.utils.utils.assignServicesFromObject(items)
        console.log('relat.items', items)
        loadGrid(items)
        show = false
    }

    function loadGrid(items: ServicesOnInvoices[]) {
        const grouped = new Map<string, ServiceRow>()
        for (const el of items) {
            const key = el.serviceId || '-'
            let acc = grouped.get(key)
            if (!acc) {
                acc = { name: el.service?.name || '[sem serviço]', value: 0, sales: 0 }
                grouped.set(key, acc)
            }
            acc.value += (el.value || 0) * (el.quantity || 0)
            acc.sales += 1
        }

        grid = new GridClass()
        grid.title = 'Ticket médio por serviço (por venda)'
        grid.cols.push(new GridCol({ content: 'Serviço' }))
        grid.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Nº de Vendas', type: GridColTypeEnum.int, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Ticket Médio', type: GridColTypeEnum.float_2 }))

        const rows = [...grouped.values()].filter((row) => row.value !== 0 && row.sales !== 0).sort((a, b) => a.name.localeCompare(b.name))
        for (const row of rows) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: row.name })
            line.slots.push({ content: row.value })
            line.slots.push({ content: row.sales })
            line.slots.push({ content: row.value / row.sales })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        grid = grid
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
